import useRequest from 'src/hooks/request/useRequest';
const getConfigAPIConfig = () => ({
    url: '/config',
    method: 'get',
});
export function useConfigAPI() {
    return useRequest(getConfigAPIConfig);
}
